var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"indication-time-video-frame"}},[_vm._v("\n    "+_vm._s(_vm.time)+" "),_c('br'),_c('br'),_c('button',{on:{"click":_vm.debugButton}},[_vm._v("Pause/Play")])])}
var staticRenderFns = []

export { render, staticRenderFns }